export const extractLocalizedValue = (data) => {
    if (!data) return "";

    const lang = localStorage.getItem("language") || "en";

    if (typeof data === "string") return data.trim?.() || data;

    if (Array.isArray(data)) {
        const found = data.find((entry) => entry?.language === lang);
        if (found?.content) return String(found.content).trim();

        const fallback = data.find((entry) => entry?.language === "en");
        if (fallback?.content) return String(fallback.content).trim();

        return "";
    }

    if (typeof data === "object") {
        return data[lang]?.trim?.() || data["en"]?.trim?.() || "";
    }

    return "";
};
